import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';
import { AccountPort } from '../../domain/ports/AccountPort';
import { RepositoryError } from '../../domain/errors';
import { ILoggerService } from '../../domain/services/LoggerService';

export class FirebaseAccountAdapter implements AccountPort {
  private readonly prefix = 'account';
  private readonly logger: ILoggerService;

  constructor(logger: ILoggerService) {
    this.logger = logger;
  }

  async changePassword(newPassword: string): Promise<void> {
    const startTime = Date.now();
    const functionName = `${this.prefix}-changePassword`;
    this.logger.logRepositoryRequest('AccountAdapter', 'changePassword', { functionName });
    
    try {
      const changePasswordFn = httpsCallable(functions, functionName);
      const result = await changePasswordFn({ newPassword });
      
      if (!result.data || !(result.data as any).success) {
        throw RepositoryError.queryFailed();
      }

      const duration = Date.now() - startTime;
      this.logger.logRepositoryResponse('AccountAdapter', 'changePassword', duration, { success: true });
    } catch (error: any) {
      const duration = Date.now() - startTime;
      this.logger.logRepositoryError('AccountAdapter', 'changePassword', duration, error);
      console.error('Change password error:', error);
      
      if (error.details?.code) {
        throw new RepositoryError(error.details.code);
      }
      
      throw RepositoryError.queryFailed();
    }
  }
}